import React from 'react';
export default function TermsFooter() {
    return(
        <div className="footer">
            <a href={`https://agreementservice.svs.nike.com/us/en_us/rest/agreement?agreementType=termsOfUse&uxId=default&country=${window.country}&language=${window.lang}&requestType=redirect`} target="_blank">Terms of Use</a><br />
            <a href={`https://agreementservice.svs.nike.com/us/en_us/rest/agreement?agreementType=privacyPolicy&uxId=default&country=${window.country}&language=${window.lang}&requestType=redirect`} target="_blank">Nike Privacy Policy</a><br />
            <a href="https://nike.com" target="_blank">Nike.com</a>
        </div>
    )
}